import { useState } from 'react'

export const useEventMedia = (setEvent) => {
  const [showUpload, setShowUpload] = useState(false)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')

  const clearSuccess = () => {
    setTimeout(() => setSuccess(''), 3000)
  }

  const clearError = () => {
    setTimeout(() => setError(''), 5000)
  }

  const handleUploadSuccess = (data) => {
    setEvent(data.event)
    setSuccess('Media uploaded successfully!')
    setShowUpload(false)
    clearSuccess()
  }

  const handleUploadError = (errorMessage) => {
    setError(errorMessage)
    clearError()
  }

  const handleMediaUpdate = (updatedEvent) => {
    setEvent(updatedEvent)
    setSuccess('Media updated successfully!')
    clearSuccess()
  }

  const toggleUpload = () => {
    setShowUpload(!showUpload)
  }

  return {
    showUpload,
    success,
    error,
    handleUploadSuccess,
    handleUploadError,
    handleMediaUpdate,
    toggleUpload
  }
}